// location could be a store object like

// {
//   id,
//   storeType,
//   address: {
//     street,
//     city,
//     state,
//     zipcode
//   },
//   distance
// }

// or one like this

// {
//   "id": 5,
//   "address": {
//     "rows": [
//       " Regents Park Rd, ",
//       "Southampton"
//      ],
//      "zipcode": "SO15 8TA"
//   },
//   "phone": "02380 764 810",
//   "coordinates": {
//     "latitude": 50.9168,
//     "longitude": -1.44076
//   },
//   "distance": {
//     "miles": "34.8"
//   }
// }

// Import JS Modules
import has from 'lodash/has';
import get from 'lodash/get';
import {
  availablePickupTimes,
  availablePickupTimesShortFormat,
} from './order-timestamps';

// -----------------------------------------------------------

// There's a Proxy thing which would make this class more terse
// but it's not IE compatible
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy

class LocationFormatter {
  constructor(location) {
    this.location = location || {};

    if (has(this.location, 'address.rows')) {
      // format ought to be
      // {
      //   rows: [
      //     " Regents Park Rd, ",
      //     "Southampton"
      //   ],
      //   zipcode: "SO15 8TA"
      // }

      const { rows, zipcode } = this.location.address;
      let [street] = rows;
      let city = rows[rows.length - 2];
      let state = rows[rows.length - 1];

      // trim and remove any trailing commas
      [street, city, state] = [street, city, state].map((r) =>
        r.trim().replace(/,$/, ''),
      );

      if (city === street) {
        [city, state] = [state, ''];
      }

      this.location.address = {
        street,
        city,
        state,
        zipcode,
      };
    }
  }

  get id() {
    return this.location.id;
  }

  get name() {
    return ['name', 'title', 'address.city'].reduce(
      (result, key) => result || get(this.location, key, ''),
      null,
    );
  }

  get storeType() {
    return this.location.storeType;
  }

  get address() {
    return this.location.address;
  }

  get phone() {
    return this.location.phone;
  }

  get coordinates() {
    return this.location.coordinates;
  }

  get distance() {
    return this.location.distance;
  }

  get pickupTimes() {
    return availablePickupTimes(this.location.orderTimestamps);
  }

  get pickupTimesFormatted() {
    return availablePickupTimesShortFormat(this.location.orderTimestamps);
  }
}

// -----------------------------------------------------------

export default LocationFormatter;
